import React from 'react';
import { useLocation } from 'react-router-dom';
import EmailSettingsPanel from '../../../../sendgrid/settings/email/components/EmailSettingsPanel';
import SMSSettingsPanel from '../../../../sms/settings/components/SMSSettingsPanel';
import { useAuth } from '../../../../context/AuthContext';
import TutorialBanner from '../../../tutorial/ui/TutorialBanner';
import '../../styles/segmented-tabs.css';

const NotificationsRemindersSettings = ({ messagingTab, onMessagingTabChange }) => {
  const { user, companyData } = useAuth();
  const location = useLocation();
  const companyId = user?.companyId;
  const fromTutorial = Boolean(location.state?.fromTutorial);

  const isEmail = messagingTab !== 'sms';

  return (
    <div className="settings-segmented-tabs">
      <div className="nr-tabs" role="tablist" aria-label="Notification channels">
        <button
          type="button"
          role="tab"
          id="settings-notifications-tab-email"
          aria-selected={isEmail}
          aria-controls="settings-notifications-panel-email"
          tabIndex={0}
          className={`nr-tabs__tab${isEmail ? ' is-active' : ''}`}
          onClick={() => onMessagingTabChange('email')}
        >
          Email
        </button>
        <button
          type="button"
          role="tab"
          id="settings-notifications-tab-sms"
          aria-selected={!isEmail}
          aria-controls="settings-notifications-panel-sms"
          tabIndex={0}
          className={`nr-tabs__tab${!isEmail ? ' is-active' : ''}`}
          onClick={() => onMessagingTabChange('sms')}
        >
          SMS
        </button>
      </div>

      <div className="nr-tabpanels">
        <div
          id="settings-notifications-panel-email"
          role="tabpanel"
          aria-labelledby="settings-notifications-tab-email"
          hidden={!isEmail}
          className="nr-tabpanel"
        >
          {isEmail && companyId ? <EmailSettingsPanel companyId={companyId} /> : null}
        </div>

        <div
          id="settings-notifications-panel-sms"
          role="tabpanel"
          aria-labelledby="settings-notifications-tab-sms"
          hidden={isEmail}
          className="nr-tabpanel"
        >
          {!isEmail && companyId ? (
            <>
              {fromTutorial ? (
                <TutorialBanner
                  description="Turn on appointment reminders via SMS and/or Email and choose how many hours before the appointment to notify clients."
                  onDismiss={() => {}}
                />
              ) : null}
              <SMSSettingsPanel companyId={companyId} companyData={companyData} />
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default NotificationsRemindersSettings;
